const CONSTANT = {
  PA20_API: {
    LOCAL: 'http://localhost:8086',
    DEV: 'https://pa20-dev.api.playauto.io',
    STAGING: 'https://pa20-staging.api.playauto.io',
    PSTAGING: 'https://pa20-pstag.api.playauto.io',
    MASTER: 'https://openapi.playauto.io'
  },
  APP: {
    LOCAL: 'http://localhost:9000',
    DEV: 'https://dev.playauto.io',
    STAGING: 'https://staging.playauto.io',
    PSTAGING: 'https://pstaging.playauto.io',
    MASTER: 'https://app.playauto.io'
  },
};

const getEnvVariables = env => {
  switch (env) {
    case undefined:
    case null:
    case 'development':
      return {
        backendUrl: CONSTANT.PA20_API.LOCAL,
        appUrl: CONSTANT.APP.LOCAL,
      };
    case 'staging':
      // TODO: dev에서 테스트중이라 dev로 연결되게 해둠
      return {
        backendUrl: CONSTANT.PA20_API.DEV,
        appUrl: CONSTANT.APP.DEV,
      };
      // return {
      //   backendUrl: CONSTANT.PA20_API.STAGING,
      //   appUrl: CONSTANT.APP.STAGING,
      // };
    default:
      return {
        backendUrl: CONSTANT.PA20_API.MASTER,
        appUrl: CONSTANT.APP.MASTER,
      };
  }
};

const config = {
  ...getEnvVariables(process.env.REACT_APP_ENV)
};

Object.freeze(config);

export default config;